import { LabChevronUpIcon } from 'components/camperlab/icons/chevron-up';
import { useCallback, useEffect, useRef } from 'react';
import { Button } from 'react-aria-components';

export function TopScrollButton() {
  const io = useRef<IntersectionObserver | null>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const callbackRef = useCallback((node: HTMLDivElement) => {
    //add an event listener for scroll that updates a data property on the node data-whow

    if (
      node !== null &&
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
      io.current = new IntersectionObserver((entries) => {
        // el innerheight es por el top con vh
        // este calculo determina si el observer esta en la parte de arriba o abajo para mostrar o no el boton
        if (buttonRef.current) {
          if (window.innerHeight - (entries[0]?.boundingClientRect.y ?? 0) < 0) {
            buttonRef.current.dataset.show = 'false';
          } else {
            buttonRef.current.dataset.show = 'true';
          }
        }
      });
      io.current.observe(node);
    }
  }, []);

  useEffect(() => {
    // TODO: en react 19 mover al callback
    return () => {
      if (io.current) {
        io.current.disconnect();
      }
    };
  }, []);

  return (
    <>
      <div ref={callbackRef} className="absolute left-0 top-[calc(100vh+400px)] h-px w-px"></div>
      <Button
        ref={buttonRef}
        onPress={() => {
          if (window && window.document) {
            window.document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }}
        data-show="false"
        className="fixed bottom-5 left-1/2 z-[10] hidden size-7 -translate-x-1/2 items-center justify-center rounded-full bg-clear text-copy shadow-xl data-[show=true]:flex"
      >
        <LabChevronUpIcon />
      </Button>
    </>
  );
}
